
import Vue from 'vue'
import { v4 as uuid } from 'uuid'
import { CSSProperties } from "vue/types/jsx"
import SingleBayCell from "./SingleBayCell.vue"
import { mapActions, mapGetters } from "vuex"

interface Container {
  id: string
  x: number
  y: number
  width: number
  height: number
  fill: string
  stroke: string
  strokeWidth: number
  type: string
  isReefer: boolean
  is45Foot: boolean
  isTank: boolean
  isFlatRack: boolean
  isOpenTop: boolean
  isPlatform: boolean
}

export default Vue.extend({
  components: {
    SingleBayCell
  },
  props: {
    data: {
      type: Object as () => {
        cols: number
        rows: number
        cells: {
          existed: boolean
          isReefer: boolean
          is45Foot: boolean
          isTank: boolean
          isFlatRack: boolean
          isOpenTop: boolean
          isPlatform: boolean
        }[]
      },
      default: () => ({
        cols: 5,
        rows: 5,
        cells: [{
          existed: true,
          isReefer: true,
          is45Foot: true,
          isTank: false,
          isFlatRack: false,
          isOpenTop: false,
          isPlatform: false,
        }, {
          existed: false,
          isReefer: true,
          is45Foot: false,
          isTank: false,
          isFlatRack: false,
          isOpenTop: false,
          isPlatform: false,
        }]
      })
    },
    name: {
      type: String,
      default: '01'
    }
  },
  data() {
    return {
      CELL_WIDTH: 100,
      // Upload images
      reeferImage: process.env.VUE_APP_BASE_URL + "media/svg/vesselProfile/Reefer.svg",
      hazardousImage: process.env.VUE_APP_BASE_URL + "media/svg/vesselMonitoring/hazardous.svg",
      highCubeImage: process.env.VUE_APP_BASE_URL + "media/svg/vesselMonitoring/highcube.svg",
      fortyFooterImage: process.env.VUE_APP_BASE_URL + "media/svg/vesselMonitoring/fortyfooter.svg",
      fortyFiveFooterImage: process.env.VUE_APP_BASE_URL + "media/svg/vesselMonitoring/fortyfivefooter.svg",

      // Tooltip
      stageSize: { width: 500, height: 500 },
      tooltipPosition: { x: 50, y: 50 },
      tooltipText: 'Your tooltip text here',
      tooltipVisible: true,
      tooltipKey: 0,
      tooltipStyle: {}, // This will hold the position styles for the tooltip

      textConfig: {
        fontSize: 10,
        fill: '#D0D0D0',
      },
    }
  },
  methods: {
    handleCellClick(containerData) {
      if (!containerData.existed) return
      this.setVesselMonitoringContainerDetailRequest({ containerNo: containerData.containerNo,stowageInstructionDetailCellId:containerData.stowageInstructionDetailCellId })
      this.setIsVesselMonitoringContainerDetailModalOpen(true)
    },
    getXLabels() {
      const labels: string[] = []
      const middle = this.data.cols % 2 === 0 ? this.data.cols / 2 : Math.floor(this.data.cols / 2)
      const startNumber = this.data.cols % 2 === 0 ? 1 : 0

      for (let i = 0; i < this.data.cols; i++) {
        if (this.data.cols % 2 === 0) {
          labels[middle + Math.floor((i * ((-1) ** i)) / 2)] = (i + 1).toString().padStart(2, '0')
        } else {
          labels[middle + Math.ceil((i * ((-1) ** (i - 1))) / 2)] = (startNumber + i).toString().padStart(2, '0')
        }
      }

      return labels.filter((label) => label !== undefined)
    }

    ,
    getYLabels() {
      const labels: (string | undefined)[] = []
      for (let i = this.data.rows - 1; i >= 0; i--) {
        labels.push((this.minDeckTiers + i * 2).toString())
      }
      return labels.filter((label) => label !== undefined) as string[]
    },
    getXLabelStyle(index: number): CSSProperties {
      return {
        position: 'absolute',
        left: `${this.CELL_WIDTH + index * this.CELL_WIDTH}px`,
        top: '0px'
      }
    },
    getXLabelBottomStyle(index: number): CSSProperties {
      return {
        position: 'absolute',
        left: `${this.CELL_WIDTH + index * this.CELL_WIDTH}px`,
        top: `${this.CELL_WIDTH / 2 + this.data.rows * this.CELL_WIDTH}px`
      }
    },

    getYLabelStyle(index: number): CSSProperties {
      return {
        position: 'absolute',
        left: `${this.data.cols * this.CELL_WIDTH + 65}px`,
        top: `${20 + this.CELL_WIDTH / 2 + index * this.CELL_WIDTH}px`
      }
    },

    getYLabelLeftStyle(index: number): CSSProperties {
      return {
        position: 'absolute',
        left: '20px',
        top: `${20 + this.CELL_WIDTH / 2 + index * this.CELL_WIDTH}px`
      }
    },

    getContainerStyle(container): CSSProperties {
      if (container.isInBay === false) {
        return {}
      }
      return {
        position: 'absolute',
        left: `${container.x}px`,
        top: `${10 + container.y}px`,
        width: `${this.CELL_WIDTH}px`,
        height: `${this.CELL_WIDTH}px`,
        backgroundColor: container.fill
      }
    },
    ...mapActions(["setVesselMonitoringContainerDetailRequest", 'setIsVesselMonitoringContainerDetailModalOpen']),
  },
  computed: {
    ...mapGetters(["getVesselMonitoringContainerDetail"]),

    gridSize(): CSSProperties {
      return {
        width: `${this.data?.cols * this.CELL_WIDTH}px`,
        height: `${(1 + this.data?.rows) * this.CELL_WIDTH}px`,
        position: 'relative' // For absolute positioning of children
      }
    },

    configKonva() {
      return {
        width: 100 + this.data.cols * this.CELL_WIDTH,
        height: this.data.rows * this.CELL_WIDTH + 20,
      }
    },
    containers() {
      const thisComponentRef = this
      const cols = thisComponentRef.data.cols
      const rows = thisComponentRef.data.rows
      let stroke = '#A0A0A0'
      let hoverStroke = '#000000'
      let strokeWidth = 0.3
      let hoverStrokeWidth = 1
      const newContainers = this.data.cells.map((c, index) => {

        let cellData = {
          ...c,
          id: uuid(),
          index,
          x: (index % cols) * thisComponentRef.CELL_WIDTH + 50,
          y: (rows - 1 - Math.floor(index / cols)) * thisComponentRef.CELL_WIDTH + 20,
          width: thisComponentRef.CELL_WIDTH,
          height: thisComponentRef.CELL_WIDTH,
          fill: c.color,
          stroke: stroke,
          strokeWidth: strokeWidth,
          onmouseover(evt) {
            thisComponentRef.tooltipText = `Container ${c.containerNo}-${index + 1}`
            const mousePos = evt.evt
            const stageRect = this.$refs.stage.getBoundingClientRect()
            thisComponentRef.tooltipStyle = {
              left: `${stageRect.left + mousePos.clientX + 10}px`,
              top: `${stageRect.top + mousePos.clientY - 10}px`,
              visibility: 'visible'
            }

            thisComponentRef.tooltipVisible = true


            if (c.existed) {
              const shape = evt.target
              shape.stroke(hoverStroke)
              shape.strokeWidth(hoverStrokeWidth)
              document.body.style.cursor = 'pointer'
            }
          },
          onmouseout(evt) {
            const shape = evt.target
            document.body.style.cursor = 'default'
            shape.stroke(stroke)
            shape.strokeWidth(strokeWidth)
          },
          type: 'standard', // you might want to update this based on the container type
        }

        return cellData
      })
      return newContainers
    },

  },
  mounted() {

    // load reefer image
    const reeferImage = new window.Image()
    reeferImage.src = 'media/svg/vesselProfile/Reefer.svg'
    reeferImage.onload = () => {
      // set image only when it is loaded
      this.reeferImage = reeferImage
    }

    // load hazardous image 
    const hazardousImage = new window.Image()
    hazardousImage.src = 'media/svg/vesselMonitoring/hazardous.svg'
    hazardousImage.onload = () => {
      // set image only when it is loaded
      this.hazardousImage = hazardousImage
    }

    // load highcube image
    const highCubeImage = new window.Image()
    highCubeImage.src = 'media/svg/vesselMonitoring/highcube.svg'
    highCubeImage.onload = () => {
      // set image only when it is loaded
      this.highCubeImage = highCubeImage
    }


    const fortyFooterImage = new window.Image()
    fortyFooterImage.src = 'media/svg/vesselMonitoring/fortyfooter.svg'
    fortyFooterImage.onload = () => {
      // set image only when it is loaded
      this.fortyFooterImage = fortyFooterImage
    }

    const fortyFiveFooterImage = new window.Image()
    fortyFiveFooterImage.src = 'media/svg/vesselMonitoring/fortyfivefooter.svg'
    fortyFiveFooterImage.onload = () => {
      // set image only when it is loaded
      this.fortyFiveFooterImage = fortyFiveFooterImage
    }
  }
})
